import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useFanPublicationStore } from "%/stores/fan-publication-store";
import { useFeedStore } from "~/stores/feed-store";

export const useFeedGroupBlogPostFeedStore = defineSmartFeedPiniaStore("feed-group-blog-post-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      publicationId: useFanPublicationStore().publicationId,
      feedGroupId: useFeedStore().feedGroupId,
    },
  }),
  getters: {
    hasMore() {
      return this.metadata.hasMore;
    },
    feedUrl() {
      `/feeds/publication/${this.metadata.publicationId}/feed-group/${this.metadata.feedGroupId}/posts/smart-feed`;
    },
  },
});
